/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_New_Term_DefaultInputs */

const en_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Term`)
};

const fr_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau terme`)
};

const de_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Amtszeit`)
};

const it_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo termine`)
};

const ru_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый срок`)
};

const es_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo término`)
};

const zh_cn2_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新学期`)
};

const ja_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新学期`)
};

const hi_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया शब्द`)
};

const pt_pt2_knp_lookup_new_term_default = /** @type {(inputs: Knp_Lookup_New_Term_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo período`)
};

/**
* | output |
* | --- |
* | "New Term" |
*
* @param {Knp_Lookup_New_Term_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_new_term_default = /** @type {((inputs?: Knp_Lookup_New_Term_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_New_Term_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_new_term_default(inputs)
	if (locale === "de") return de_knp_lookup_new_term_default(inputs)
	if (locale === "it") return it_knp_lookup_new_term_default(inputs)
	if (locale === "ru") return ru_knp_lookup_new_term_default(inputs)
	if (locale === "es") return es_knp_lookup_new_term_default(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_new_term_default(inputs)
	if (locale === "ja") return ja_knp_lookup_new_term_default(inputs)
	if (locale === "hi") return hi_knp_lookup_new_term_default(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_new_term_default(inputs)
	return en_knp_lookup_new_term_default(inputs)
});